import { render, staticRenderFns } from "./LawEventTypeList.vue?vue&type=template&id=637a7342&"
import script from "./LawEventTypeList.vue?vue&type=script&lang=js&"
export * from "./LawEventTypeList.vue?vue&type=script&lang=js&"
import style0 from "./LawEventTypeList.vue?vue&type=style&index=0&id=637a7342&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports